import { QUOTE_REQUEST_STATUSES, type QuoteRequestStatus } from '@repo/api-contracts';

/** 견적 내역 메뉴의 상태 — 처리할 건(REQUESTED·REVISION_REQUESTED)을 뺀 나머지 전부(발행 뒤·끝난 건). */
export const QUOTE_HISTORY_STATUSES: readonly QuoteRequestStatus[] = QUOTE_REQUEST_STATUSES.filter(
  (status) => status !== 'REQUESTED' && status !== 'REVISION_REQUESTED',
);

/**
 * 견적 목록 상태 필터 — DEFAULT 는 처리할 건(REQUESTED·REVISION_REQUESTED, 서버 기본값, "견적 요청" 메뉴),
 * HISTORY 는 그 나머지 전부("견적 내역" 메뉴), ALL 은 전체, 그 외는 그 상태 하나.
 */
export type QuoteStatusFilter = 'DEFAULT' | 'HISTORY' | 'ALL' | QuoteRequestStatus;

/** 필터 → 서버 입력. DEFAULT 는 입력에서 빼서 서버 기본값을 쓴다. */
export const statusesForFilter = (filter: QuoteStatusFilter): QuoteRequestStatus[] | undefined => {
  if (filter === 'DEFAULT') {
    return undefined;
  }

  if (filter === 'HISTORY') {
    return [...QUOTE_HISTORY_STATUSES];
  }

  if (filter === 'ALL') {
    return [...QUOTE_REQUEST_STATUSES];
  }

  return [filter];
};
